module.exports = __webpack_public_path__ + "img/depmap_svg_V181.429f038f.svg";